// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__yEgVW","content":"Modal_content__yBmFf","zoom":"Modal_zoom__mVI9G","close":"Modal_close__nnot4"};